import {
    AccountsService,
    ContactsService,
    DashboardService,
    LeadsService,
    NotesService,
    TasksService,
    LocationService,
    EmployeesService,
    MasterdataAService,
    SalaryScaleGroupService
} from '../../services';

export const crmState: aboTheme.IState = {
  parent: "app",
  name: "crm",
  url: "/crm",
  redirectTo: "crm.dashboard",
  component: "crmComponent",
  data: {
    permissions: {
        only: ['BACKOFFICE'],
        redirectTo: 'schedule'
    }
  }
};

export const crmDashboardState: aboTheme.IState = {

  name: "crm.dashboard",
  url: "/dashboard",
  resolve: {
    accounts: (AccountsService: AccountsService) => { 'ngInject'; return AccountsService.all(); },
    contacts: (ContactsService: ContactsService) => { 'ngInject'; return ContactsService.all(); }, 
    summary: (DashboardService: DashboardService) => { 'ngInject'; return DashboardService.one(); },
    notes: (NotesService: NotesService) => { 'ngInject'; return NotesService.all({sortfield: 'date'}); },
  },
  views: {
    "main": 'crmDashboardComponent'
  }
};


export const accountsState: aboTheme.IState = {
  name: "crm.accounts",
  url: "/accounts",
  redirectTo: "crm.accounts.list",
  views: {
    "main" : "accountsComponent"
  }
};

export const accountsListState: aboTheme.IState = {
  name: "crm.accounts.list",
  url: "/list",  
  resolve: {
    accounts: (AccountsService: AccountsService) => { 'ngInject'; return AccountsService.all(); },

  },
  views: {
      "main": 'accountsListComponent'
  }
};

export const accountsItemState: aboTheme.IState = {
  name: "crm.accounts.item",
  url: "/:id",
  params : {
    "tab" : null
  },
  resolve: {
    account: (AccountsService: AccountsService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return AccountsService.get($stateParams['id']); } },
    contacts: (AccountsService: AccountsService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return AccountsService.getChild($stateParams['id'], 'contacts'); } },
    notes: (AccountsService: AccountsService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return AccountsService.getChild($stateParams['id'], 'notes' ); } },
    locations: (AccountsService: AccountsService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return AccountsService.getChild($stateParams['id'], 'locations'); } },
    agreements: (AccountsService: AccountsService, $stateParams: ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return AccountsService.customGet($stateParams['id'] + '/agreements'); } },
    accountEmployees: (AccountsService: AccountsService, $stateParams: ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return AccountsService.customGet($stateParams['id'] + '/employees'); } },
    reminderIntervals: (AccountsService: AccountsService, $stateParams: ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return AccountsService.customGet($stateParams['id'] + '/nomatchfoundemailsettings'); } },
  },
  views: {
      "main": 'accountsItemComponent'
  }
};

export const locationsItemState: aboTheme.IState = {

  name: "crm.accounts.item.location",
  url: "/location/:locationId",
  params: {
    "locationId": null
  },
  modal: ['account', 'locations'],
  resolve: {
  },
  component: 'locationsItemComponent'

};

export const teamsItemState: aboTheme.IState = {

  name: "crm.accounts.item.team",
  url: "/team/:locationId/:teamId",
  params: {
    "locationId": null,
    "teamId": null
  },
  modal: ['locations', 'contacts'],
  resolve: {
  },
  component: 'teamsItemComponent'

};

export const agreementsItemState: aboTheme.IState = {

  name: "crm.accounts.item.agreement",
  url: "/agreement/:agreementId",
  params: {
    "agreementId": null
  },
  modal: ['account', 'agreements'],
  resolve: {
    employees: (EmployeesService: EmployeesService) => { 'ngInject'; return EmployeesService.getEmployeesByStatus(); },
    salaryScales : (MasterdataAService:MasterdataAService) => { "ngInject"; return MasterdataAService.getItems('WageCodes'); }
  },
  component: 'agreementsItemComponent'

};

export const accountEmployeesItemState: aboTheme.IState = {

  name: "crm.accounts.item.employee",
  url: "/employee/:accountEmployeeId",
  params: {
    "accountEmployeeId": null
  },
  modal: ['account', 'accountEmployees'],
  resolve: {
    employees: (EmployeesService: EmployeesService) => { 'ngInject'; return EmployeesService.getEmployeesByStatus(); }
  },
  component: 'accountEmployeesItemComponent'

};


export const contactsState: aboTheme.IState = {
  name: "crm.contacts",
  url: "/contacts",
  redirectTo: "crm.contacts.list",
  views: {
    "main" : "contactsComponent"
  }
};

export const contactsListState: aboTheme.IState = {
  name: "crm.contacts.list",
  url: "/list",
  params: {
    accountId: null,
  },
  resolve: {
    accounts: (AccountsService: AccountsService) => { 'ngInject' ; return AccountsService.all() },
    contacts: (ContactsService: ContactsService) => { 'ngInject'; return ContactsService.all() },
  },
  views: {
      "main": 'contactsListComponent'
  }
};

export const contactsItemState: aboTheme.IState = {
  name: "crm.contacts.item",
  url: "/:id",
  params: {
    accountId: null,
  },
  resolve: {
    contact: (ContactsService: ContactsService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return ContactsService.get($stateParams['id']); } },
    notes: (ContactsService: ContactsService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return ContactsService.getChild($stateParams['id'], 'notes'); } },
  },
  views: {
      "main": 'contactsItemComponent'
  }
};

export const leadsState: aboTheme.IState = {
  name: "crm.leads",
  url: "/leads",
  redirectTo: "crm.leads.list",
  views: {
    "main" : "leadsComponent"
  }
};

export const leadsListState: aboTheme.IState = {
  name: "crm.leads.list",
  url: "/list",
  resolve: {
    leads: (LeadsService: LeadsService) => { 'ngInject'; return LeadsService.all(); }
  },
  views: {
      "main": 'leadsListComponent'
  }
};

export const leadsItemState: aboTheme.IState = {
  name: "crm.leads.item",
  url: "/:id",
  resolve: {
    lead: (LeadsService: LeadsService, $stateParams:ng.ui.IStateParamsService) => { 'ngInject'; if ($stateParams['id'] != '') { return LeadsService.get($stateParams['id']); } }
  },
  views: {
      "main": 'leadsItemComponent'
  }
};

export const reminderItemState: aboTheme.IState = {

  name: "crm.accounts.item.reminder",
  url: "/reminder/:index",
  params: {
    "index": null
  },
  modal: ['reminderIntervals'],
  resolve: {
  },
  component: 'reminderIntervalComponent'

};



// WEBPACK FOOTER //
// ./src/app/modules/crm/crm.states.ts